import { Link } from "react-router-dom";
import { CalendarCheck, LockKeyhole, RefreshCw, ShieldCheck, TrendingUp } from "lucide-react";

// Public launch date shown on the homepage. Update this single constant if the
// date changes — the badge, the copy and the structured data all read from it.
export const LAUNCH_DATE_ISO = "2026-09-06";
export const LAUNCH_DATE_LABEL = "6 September 2026";

// NOTE: no customer quotes are shown until real, attributable ones are
// supplied. Everything in this section is a fact a visitor can verify
// themselves (open the free samples, read the terms, check the refund window).
const proofPoints = [
  {
    icon: TrendingUp,
    label: "35+ sources scanned daily",
    note: "Scoring refreshes whether you log in or not.",
  },
  {
    icon: LockKeyhole,
    label: "3 full blueprints, free to read",
    note: "No card, no signup — open the marketplace and judge the output yourself.",
  },
  {
    icon: ShieldCheck,
    label: "14-day full refund",
    note: "No questions, no forms — just email info@skaiboss.com.",
  },
  {
    icon: RefreshCw,
    label: "No upsells, ever",
    note: "One $39 lifetime licence covers every future source and feature.",
  },
  {
    icon: CalendarCheck,
    label: `Publicly launched ${LAUNCH_DATE_LABEL}`,
    note: "Every buyer since day one is on the same $39 licence.",
  },
];

const Trust = () => (
  <section id="proof" className="py-24 border-t border-border" aria-labelledby="trust-heading">
    <div className="container mx-auto px-6">
      <div className="max-w-2xl">
        <div className="font-mono text-xs text-primary mb-3">// TRUST &amp; PROOF</div>
        <h2 id="trust-heading" className="font-display text-3xl md:text-5xl font-bold">
          Judge the product, not the marketing
        </h2>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          Trends Discovery went live on{" "}
          <time dateTime={LAUNCH_DATE_ISO} className="text-foreground font-medium">
            {LAUNCH_DATE_LABEL}
          </time>
          . We're new, so instead of quoting customers we can't yet name, we open the
          work up: read three complete launch blueprints for free and decide before
          you pay a cent.
        </p>
      </div>

      <ul className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {proofPoints.map(({ icon: Icon, label, note }) => (
          <li
            key={label}
            className="flex items-start gap-3 rounded-xl border border-border bg-card p-5"
          >
            <Icon className="size-5 text-primary shrink-0 mt-0.5" aria-hidden="true" />
            <div>
              <div className="text-sm font-medium">{label}</div>
              <div className="text-xs text-muted-foreground mt-1">{note}</div>
            </div>
          </li>
        ))}
      </ul>

      <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
        <Link to="/marketplace" className="text-primary hover:underline font-medium">
          Browse the trend marketplace →
        </Link>
        <Link to="/roadmap" className="text-primary hover:underline">
          See what's shipping next
        </Link>
        <Link to="/account" className="text-muted-foreground hover:text-foreground">
          Already bought? Manage your licence
        </Link>
      </div>
    </div>
  </section>
);

export default Trust;
